module.exports = __webpack_public_path__ + "article-7051a3ee/yaroslav-olieinikov-cf4a15ba29f70a6b835a36c92058c494.jpg";